/**
 * Capture attribution from the browser for website Lead intake.
 * Call on submit - not on mount - so SPA navigations still send the landing URL.
 */

const UTM_KEYS = [
 'utm_source',
 'utm_medium',
 'utm_campaign',
 'utm_term',
 'utm_content'
];

function readSearchParams() {
 if (typeof window === 'undefined') {
 return new URLSearchParams();
 }
 return new URLSearchParams(window.location.search);
}

/**
 * @returns {{
 * pageUrl: string,
 * landingPage: string,
 * referrer: string,
 * utmSource: string,
 * utmMedium: string,
 * utmCampaign: string,
 * utmTerm: string,
 * utmContent: string,
 * }}
 */
export function captureAttribution() {
 const params = readSearchParams();
 const pageUrl =
 typeof window !== 'undefined'
 ? `${window.location.origin}${window.location.pathname}${window.location.search}`
 : '';

 let landingPage = pageUrl;
 try {
 const stored =
 typeof sessionStorage !== 'undefined'
 ? sessionStorage.getItem('elm_landing_page')
 : null;
 if (stored) {
 landingPage = stored;
 } else if (typeof sessionStorage !== 'undefined' && pageUrl) {
 sessionStorage.setItem('elm_landing_page', pageUrl);
 }
 } catch {
 // sessionStorage may be blocked
 }

 const referrer =
 typeof document !== 'undefined' ? String(document.referrer || '') : '';

 const utms = {};
 UTM_KEYS.forEach((utmKey) => {
 const camel = utmKey.replace(/_([a-z])/g, (_match, letter) => letter.toUpperCase());
 utms[camel] = String(params.get(utmKey) || '').trim();
 });

 return {
 pageUrl,
 landingPage,
 referrer,
 utmSource: utms.utmSource || '',
 utmMedium: utms.utmMedium || '',
 utmCampaign: utms.utmCampaign || '',
 utmTerm: utms.utmTerm || '',
 utmContent: utms.utmContent || ''
 };
}

/**
 * Stable id for support/debug; generated once per submit attempt.
 */
export function createFormSubmissionId() {
 if (typeof crypto !== 'undefined' && crypto.randomUUID) {
 return crypto.randomUUID();
 }
 return `form-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
